import { render, staticRenderFns } from "./OlympicsStatusModal.vue?vue&type=template&id=ebf810f8"
import script from "./OlympicsStatusModal.vue?vue&type=script&lang=js"
export * from "./OlympicsStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports